import { CABIN_CLASS } from '@web-platform/shared-universal-constants/src/cabinClass';

import type { CabinClass } from '@web-platform/shared-universal-constants/src/cabinClass';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

export const fpsCabinClassToCabinClass = (fpsCabinClass: Nullable<string>): CabinClass => {
  if (!fpsCabinClass) return CABIN_CLASS.ECONOMY;

  switch (fpsCabinClass) {
    case 'economy':
      return CABIN_CLASS.ECONOMY;
    case 'premium_economy':
    case 'premiumeconomy':
      return CABIN_CLASS.PREMIUM_ECONOMY;
    case 'business':
      return CABIN_CLASS.BUSINESS;
    case 'first':
      return CABIN_CLASS.FIRST;
    default:
      return CABIN_CLASS.ECONOMY;
  }
};
